// Noodl SDK - webpack handles this require properly
const Noodl = require('@noodl/noodl-sdk');
const React = require('react');
import { ProjectList } from '@shared/components/ProjectList/ProjectList';

export const ProjectListNode = Noodl.defineReactNode({
	name: 'Prodikt Project List',
	category: 'Prodikt Views',
	getReactComponent() {
		return ProjectList;
	},
	inputProps: {
		// Required
		id: {
			type: 'string',
			displayName: 'Project ID',
			group: 'General'
		},
		name: {
			type: 'string',
			displayName: 'Name',
			group: 'General'
		},
		lastEdited: {
			type: 'string',
			displayName: 'Last Edited',
			group: 'General'
		},

		// Optional Details
		client: {
			type: 'string',
			displayName: 'Client',
			group: 'Details'
		},
		clientLabel: {
			type: 'string',
			displayName: 'Client Label',
			default: 'Kund',
			group: 'Details'
		},
		size: {
			type: 'string',
			displayName: 'Size',
			group: 'Details'
		},
		sizeLabel: {
			type: 'string',
			displayName: 'Size Label',
			default: 'Storlek',
			group: 'Details'
		},
		location: {
			type: 'string',
			displayName: 'Location',
			group: 'Details'
		},
		locationLabel: {
			type: 'string',
			displayName: 'Location Label',
			default: 'Plats',
			group: 'Details'
		},
		image: {
			type: 'object',
			displayName: 'Image',
			group: 'Details'
		},

		// Project Type
		type: {
			type: {
				name: 'enum',
				enums: [
					{ label: 'Private', value: 0 },
					{ label: 'Team', value: 1 },
					{ label: 'Team Editing', value: 2 }
				]
			},
			displayName: 'Type',
			default: 0,
			group: 'General'
		},

		// Labels
		labels: {
			type: 'array',
			displayName: 'Labels',
			group: 'Details'
		},

		// Not Entered Text
		notEntered: {
			type: 'string',
			displayName: 'Not Entered Text',
			default: '',
			group: 'Details'
		},

		// Menu
		menuActions: {
			type: 'array',
			displayName: 'Menu Actions',
			group: 'Menu'
		}
	},
	outputProps: {
		onClick: {
			type: 'signal',
			displayName: 'Clicked'
		},
		projectId: {
			type: 'string',
			displayName: 'Project ID'
		},
		onMenuAction: {
			type: 'signal',
			displayName: 'Menu Action'
		},
		actionId: {
			type: 'string',
			displayName: 'Action ID'
		}
	},
	setup: function(context, graphModel) {
		if (!context.propsInput) context.propsInput = {};
	},
	initialize: function() {
		// Set up onClick handler
		this.props.onClick = () => {
			const projectId = this.inputs.id;
			this.setOutputs({ projectId });
			this.sendSignalOnOutput('onClick');
		};

		// Set up onMenuAction handler
		this.props.onMenuAction = (projectId, actionId) => {
			this.setOutputs({ projectId, actionId });
			this.sendSignalOnOutput('onMenuAction');
		};
	}
});
